class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-link');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ---- Complete your set: scroll arrows + add to bag (delegated, survives drawer re-renders) ---- */
(function () {
  if (window.__leniCysInit) return;
  window.__leniCysInit = true;

  function addUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url + '.js';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function updateArrows(track) {
    var wrap = track.closest('.cys');
    if (!wrap) return;
    var prev = wrap.querySelector('.cys-arrow--prev');
    var next = wrap.querySelector('.cys-arrow--next');
    if (!prev || !next) return;
    var max = track.scrollWidth - track.clientWidth;
    prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
    next.classList.toggle('is-disabled', track.scrollLeft >= max - 2);
  }

  // Scroll events don't bubble, so listen in the capture phase
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('cys-track')) updateArrows(e.target);
  }, true);

  // Stop the size dropdown from triggering the cart's quantity-change handler
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('.cys')) return;
    e.stopPropagation();
    var card = e.target.closest('.cys-card');
    var err = card && card.querySelector('.cys-card__error');
    if (err) err.textContent = '';
  }, true);

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.cys-arrow');
    if (arrow) {
      e.preventDefault();
      var track = arrow.closest('.cys').querySelector('.cys-track');
      var firstCard = track.querySelector('.cys-card');
      var step = firstCard ? firstCard.getBoundingClientRect().width + 14 : 200;
      track.scrollBy({ left: arrow.classList.contains('cys-arrow--prev') ? -step : step, behavior: 'smooth' });
      return;
    }

    var btn = e.target.closest('.cys-add');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.cys-card');
    var err = card.querySelector('.cys-card__error');
    var select = card.querySelector('select');
    var variantId = btn.dataset.variantId || (select && select.value);
    if (!variantId) { if (err) err.textContent = 'Please select a size'; return; }
    if (err) err.textContent = '';
    btn.classList.add('is-loading');

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { if (err) err.textContent = data.description || data.message || 'Could not add this size.'; return; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections && typeof drawer.renderContents === 'function') { drawer.renderContents(data); }
        else { window.location.reload(); }
      })
      .catch(function () { if (err) err.textContent = 'Something went wrong, please try again.'; })
      .finally(function () { btn.classList.remove('is-loading'); });
  });
})();
